// extracted by mini-css-extract-plugin
export default {"addTestBtn":"addTestBtn-rkG6b","text":"text-hxO2r"};